<template>
  <div>
    <v-card>
      <v-toolbar flat color="white">
        <v-toolbar-title>
          <v-icon class="mb-1">mdi-airport</v-icon>
          AEROPUERTOS
        </v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
        <v-col cols="2" class="pr-0">
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Buscar"            
            clearable
            class="mt-5 mx-1"
          ></v-text-field>
        </v-col>
        <v-col cols="2" class="pr-0">
            <v-select class="mt-5 mx-1"
                v-model="tipoPuerto"
                :items="tiposPuertoFiltro"
                label="Tipo de Puerto"
                clearable
                @change="cargarLista"></v-select> 
        </v-col>
        <v-col cols="3" class="pr-0">
        <v-checkbox
          class="mt-5 mx-1"
          v-model="incluirInactivos"
          label="Incluir inactivos"
          @change="cargarLista"
        ></v-checkbox>
        </v-col>
        <v-spacer></v-spacer>
        <v-btn small color="primary" @click="abrirDialogAeropuerto(null)">
          <v-icon>mdi-plus-circle-outline</v-icon> Nuevo aeropuerto
        </v-btn>
      </v-toolbar>
      <v-data-table
        :headers="headers"
        :items="lista"
        :items-per-page="itemsPerPage"
        :search="search"
        :loading="loadingTable"
        class="elevation-1"
      >
        <template v-slot:item.opcion="{ item }">
          <v-btn
            icon
            color="green"
            @click="abrirDialogAeropuerto(item.AEROPUERTO_ID)"
          >
            <v-icon>mdi-pencil</v-icon>
          </v-btn>

          <v-btn
            icon
            color="red"
            @click="eliminarAeropuerto(item.AEROPUERTO_ID)"
          >
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </template>

        <template v-slot:item.ACTIVO="{ item }">
          {{ item.ACTIVO == "1" ? "ACTIVO" : "INACTIVO" }}
        </template>
      </v-data-table>
    </v-card>
    <!-- dialogo aeropuerto -->
    <v-dialog v-model="dialogAeropuerto" persistent max-width="600px">
      <v-card>
        <v-toolbar flat color="blue" dark height="40">
          <v-icon class="mb-1" left>mdi-airport</v-icon>
          <span class="headline"
            >Aeropuerto </span
          >
          <v-spacer></v-spacer>
          <v-btn icon @click="dialogAeropuerto = !dialogAeropuerto">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container>
            <v-form ref="formAeropuerto">
              <v-row>
                 <v-col cols="8" class="pt-0 pb-0">
                    <v-select class="mt-5 mx-1" 
                        v-model="datosAeropuerto.TIPO" 
                        :items="tiposPuerto" 
                        label="Tipo de Puerto" 
                        @change="cargarPuertoTipo"></v-select> 
                </v-col> 
                <v-col class="pt-4 pb-0" cols="2">
                  <v-checkbox
                    v-model="datosAeropuerto.ACTIVO"
                    label="Activo"
                    :true-value="1"
                    :false-value="0"
                  ></v-checkbox>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="pt-0 pb-0" cols="12">
                  <v-text-field
                    :rules="requiredRule"
                    v-model="datosAeropuerto.AP_NOMBRE"
                    label="Nombre "
                  >
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="pt-0 pb-0" cols="6">
                  <v-autocomplete
                    :rules="requiredRule"
                    :items="paises"
                    item-text="CIUPA_DESC"
                    item-value="CIUPA_ID"
                    v-model="datosAeropuerto.CIUPA_ID"
                    label="Ciudad - Pais"
                    @change="cambiarCodigoPais"
                  >
                  </v-autocomplete>
                </v-col>
                <v-col class="pt-0 pb-0" cols="6">
                  <v-text-field
                    v-model="datosAeropuerto.AP_COD"
                    label="Código"
                  >
                  </v-text-field>
                </v-col>

                <v-col class="pt-0 pb-0" cols="6">
                  <v-autocomplete
                    :rules="requiredRule"
                    :items="puertos"
                    item-text="NOMBRE_PUERTO"
                    item-value="CODIGO_PUERTO"
                    v-model="datosAeropuerto.CODIGO_PUERTO"
                    label="Puerto"
                    width="100%"
                  >
                                      
                    <template v-slot:item="{ item }">             
                      <v-list-item-content>
                        <v-list-item-title >{{ item.NOMBRE_PUERTO }}</v-list-item-title>
                        <v-list-item-subtitle >{{ item.CODIGO_PUERTO }}</v-list-item-subtitle>                    
                        </v-list-item-content>                           
                    </template>
                  
                  </v-autocomplete>
                </v-col>

                <v-col class="pt-0 pb-0" cols="6">
                  <v-text-field
                    v-model="datosAeropuerto.CODIGO_PUERTO"
                    label="Codigo Agrocalidad"
                  >
                  </v-text-field>
                </v-col>
                
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-col class="text-center">
            <v-btn small color="primary" @click="guardarAeropuerto">
              <v-icon left>mdi-content-save</v-icon> Guardar
            </v-btn>
            &nbsp;&nbsp;
            <v-btn small @click="dialogAeropuerto = !dialogAeropuerto">
              <v-icon left>mdi-cancel</v-icon> Cancelar
            </v-btn>
          </v-col>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions, mapGetters } from "vuex";
import Vue from "vue";

export default {
  name: "AeropuertoComponent",
  data: () => ({
    headers: [
      { text: "Opciones", value: "opcion" },
      { text: "Codigo", value: "AP_COD" },
      { text: "Nombre", value: "AP_NOMBRE" },
      { text: "Tipo", value: "TIPO" },
      { text: "Activo", value: "ACTIVO" },
    ],

    requiredRule: [(v) => !!v || "El campo es requerido"],
    emailRules: [
      (v) =>
        String(v)
          .toLowerCase()
          .match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          ) || "Ingrese un Email válido",
    ],
    lista: [],
    options: {},
    dialog: false,
    notifications: false,
    sound: true,
    widgets: true,
    search: null,
    incluirInactivos: false,

    dialogAeropuerto: false,
    datosAeropuerto: {
      AEROPUERTO_ID: "",
      AP_NOMBRE: "",
      AP_COD: "",
      CIUPA_ID: "",
      ACTIVO: 1,
    },
    tiposPuerto: [ { text: "Aéreo", value: "AEREO" }, 
                   { text: "Marítimo", value: "MARITIMO" }, 
                   { text: "Terrestre", value: "TERRESTRE" },  
                   { text: "Puerto", value: "PUERTO" },  
                  ],
    tiposPuertoFiltro: [ 
                   { text: "Todos", value: "" },
                   { text: "Aéreo", value: "AEREO" },
                   { text: "Marítimo", value: "MARITIMO" },
                   { text: "Terrestre", value: "TERRESTRE" },
                   { text: "Puerto", value: "PUERTO" },
                  ],              
    paises: [],
    puertos: [],
    itemsPerPage: 20,
    creaAp: true,
    tipoPuerto: "",
  }),
  computed: {
    ...mapState("master", ["loadingTable", "user"]),
    ...mapGetters("access", [""]),
    
  },
  methods: {
    ...mapMutations("master", [
      "setUrl",
      "setOverlay",
      "setMenu",
      "setLoadingTable",
      "setTitleToolbar",
    ]),

    ...mapActions("master", ["requestApi", "alertNotification"]),

    
    cargarLista() {
      this.setLoadingTable(true);
      this.setUrl("api/lista-aeropuertos");
      this.requestApi({
        method: "GET",
        data: {
          incluirInactivos: this.incluirInactivos,
          tipo: this.tipoPuerto,
        },
      })
        .then((res) => {
          //console.log(res);
          this.lista = res.data;
          this.pageCount = 10;
        })
        .catch(() => {})
        .then(() => {
          this.setLoadingTable(false);
        });
    },

    modificarAeropuerto() {
      this.setUrl("api/modificar-aeropuerto");
      this.requestApi({
        method: "POST",
        data: {
          aeropuerto: this.datosAeropuerto,
        },
      })
        .then((res) => {
          this.alertNotification({ param: { html: res.data.msg } });
          this.cargarLista();
          this.dialogAeropuerto = false;
        })
        .then(() => {});
    },

    abrirDialogAeropuerto(apid) {
      this.creaAp = false;
      if (apid == null) {
        this.datosAeropuerto = {
          AEROPUERTO_ID: "",
          AP_NOMBRE: "",
          AP_COD: "",
          CIUPA_ID: "",
          CODIGO_PUERTO: "",          
          ACTIVO: 1,
        };
        this.creaAp = true;
      }
      this.setUrl("api/aeropuerto");
      this.requestApi({
        method: "GET",
        data: {
          AEROPUERTO_ID: apid,
        },
      })
        .then((res) => {
          if (res.data.aeropuerto != null) {
            this.datosAeropuerto = res.data.aeropuerto;
          }
          this.paises = res.data.pais;
          this.puertos = res.data.puertos;
          this.dialogAeropuerto = true;
        })
        .then(() => {});
    },

    eliminarAeropuerto(aeropuertoId) {
      Vue.swal({
        html: "Está seguro de eliminar el aeropuerto ?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cerrar",
        ...this.paramAlertQuestion,
      }).then((result) => {
        if (result.isConfirmed) {
          this.setUrl("api/borrar-aeropuerto");
          this.requestApi({
            method: "POST",
            data: {
              AEROPUERTO_ID: aeropuertoId,
            },
          }).then((res) => {
            //console.log(res);
            this.cargarLista();
            this.alertNotification({ param: { html: res.data.msg } });
          });
        }
      });
    },
    guardarAeropuerto() {
      if (!this.$refs.formAeropuerto.validate()) {
        return false;
      }
      if (this.creaAp == true) {
        this.crearAeropuerto();
      } else {
        this.modificarAeropuerto();
      }
    },
    crearAeropuerto() {
      console.log(this.datosAeropuerto);
      this.setUrl("api/crear-aeropuerto");
      this.requestApi({
        method: "POST",
        data: {
          aeropuerto: this.datosAeropuerto,
        },
      })
        .then((res) => {
          this.alertNotification({ param: { html: res.data.msg } });
          this.dialogAeropuerto = false;
          this.cargarLista();
        })
        .then(() => {});
    },
    cargarPuertoTipo() {
      this.setUrl("api/puertos-tipo");
      this.requestApi({
        method: "GET",
        data: {
          tipo: this.datosAeropuerto.TIPO,
        },
      })
        .then((res) => {
          this.puertos = res.data;
        })
        .catch(() => {})
        .then(() => {});
    },
    cambiarCodigoPais() {
      //this.datosAeropuerto.SHP_PAIS = this.datosAeropuerto.PAIS_COD;
    },
  },

  mounted() {
    document.title = "Sistema de carga";
    this.setTitleToolbar("Aeropuertos");
    this.cargarLista();
  },
};
</script>
